import { z } from "zod";

export const ClientRequestCreateSchema = z.object({
  type: z.enum(["DEMANDE", "RECLAMATION", "HELP"]),
  subject: z.string().min(3).max(120),
  message: z.string().min(10).max(5000),
});

export type ClientRequestCreateDto = z.infer<typeof ClientRequestCreateSchema>;

export const ClientRequestReplySchema = z.object({
  status: z.enum(["OPEN", "IN_PROGRESS", "RESOLVED"]),
  responseMessage: z.string().min(1).max(5000),
});

export type ClientRequestReplyDto = z.infer<typeof ClientRequestReplySchema>;
